import { skipToken } from '@reduxjs/toolkit/query'
import { Popover, Space, Spin, Table, Tag } from 'antd'
import { ColumnsType } from 'antd/es/table'
import { FC, useState } from 'react'
import styled from 'styled-components'
import { useGetFormSetByDocIdQuery } from '../../store/api/form-sets-api'
import Form from '../../types/api/form'
import FormSet from '../../types/api/form-set'

const Swatch = styled.div<{ $hex: string }>`
    width: 22px;
    height: 22px;
    flex-shrink: 0;
    border-radius: 4px;
    background: #${props => props.$hex};
`

const formSetSummaryPopulate = {
    populate: {
        forms: {
            fields: ['documentId', 'num', 'color', 'colorName', 'inStock', 'failureReason'],
        },
    },
}

const getFormStatus = (form: Form) => {
    if (form.failureReason) {
        return <Tag color='red'>{form.failureReason}</Tag>
    }
    if (form.inStock) return 'В наличии'
    return <Tag color='warning'>Нет</Tag>
}

const summaryColumns: ColumnsType<Form> = [
    { title: 'Номер', dataIndex: 'num', width: 120 },
    {
        title: 'Цвет',
        key: 'color',
        width: 160,
        render: (_, form) => (
            <Space>
                {form.color ? <Swatch $hex={form.color} /> : null}
                {form.colorName}
            </Space>
        ),
    },
    {
        title: 'Статус',
        key: 'status',
        width: 130,
        render: (_, form) => getFormStatus(form),
    },
]

interface FormSetNumberProps {
    formSet: Pick<FormSet, 'id' | 'documentId'>
}

const FormSetNumber: FC<FormSetNumberProps> = ({ formSet }) => {
    const [open, setOpen] = useState(false)

    const { data, isFetching } = useGetFormSetByDocIdQuery(
        open && formSet.documentId
            ? [formSet.documentId, formSetSummaryPopulate]
            : skipToken
    )

    const forms = data?.data.forms ?? []

    return (
        <Popover
            open={open}
            onOpenChange={setOpen}
            title={<>Набор № {formSet.id}</>}
            placement='rightBottom'
            content={
                isFetching && !data ? (
                    <Spin size='small' />
                ) : (
                    <Table<Form>
                        size='small'
                        pagination={false}
                        rowKey='documentId'
                        columns={summaryColumns}
                        dataSource={forms}
                    />
                )
            }
        >
            <span>{formSet.id}</span>
        </Popover>
    )
}

export default FormSetNumber
